import { useCallback, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";

import loading from "../../hooks/useLoading";
import useNotification from "../../hooks/useNotification";

import configErrors from "../../config/errors/resetPassword";

import api, { publicRequest } from "../../services/api";

const useLogin = () => {
    const history = useHistory();

    const location = useLocation();

    const { success, error } = useNotification();

    const initialData = useCallback(
        () => ({
            password: "",
            passwordConfirmation: "",
        }),
        []
    );

    const initialErrors = useCallback(
        () => ({
            password: "",
            passwordConfirmation: "",
        }),
        []
    );

    const [data, setData] = useState(initialData());

    const [errors, setErrors] = useState(initialErrors());

    const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = event.target;

        setData({ ...data, [name]: value });
    };

    const handlerValidate = () => {
        let response = true;
        let errors = initialErrors();

        if (!data.password) {
            response = false;
            errors.password = "Preencha esse campo";
        }

        if (!data.passwordConfirmation) {
            response = false;
            errors.passwordConfirmation = "Preencha esse campo";
        } else if (data.passwordConfirmation !== data.password) {
            response = false;
            errors.passwordConfirmation = "Senha de confirmação inválido";
        }

        setErrors(errors);

        return response;
    };

    const handlerOnSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        const idLoading = loading();
        try {
            if (!handlerValidate()) {
                loading(idLoading);
                return;
            }

            const serializedData = {
                ...data,
                code: new URLSearchParams(location.search).get("code"),
            };

            await api.post(
                "/auth/reset-password",
                serializedData,
                publicRequest
            );

            loading(idLoading);

            success("Recuperação de senha concluída");

            history.push("/auth");
        } catch (e) {
            error("Recuperar senha falhou", configErrors, e);

            loading(idLoading);
        }
    };

    return { data, errors, handlerOnSubmit, handleOnChange };
};

export default useLogin;
